const readEntriesPromise = (reader) => {
  return new Promise((resolve, reject) => {
    reader.readEntries(resolve, reject);
  });
};

const readAllEntries = async (reader) => {
  let allEntries = [];
  let entries;

  do {
    entries = await readEntriesPromise(reader);
    allEntries = allEntries.concat(entries);
  } while (entries.length > 0);

  return allEntries;
};

const getFileFromEntry = (entry) => {
  return new Promise((resolve, reject) => {
    entry.file(resolve, reject);
  });
};

export const readDirectoryRecursively = async (entry) => {
  const result = {
    name: entry.name,
    files: [],
    subFolders: []
  };

  const reader = entry.createReader();
  const entries = await readAllEntries(reader);

  for (const childEntry of entries) {
    if (childEntry.isFile) {
      const file = await getFileFromEntry(childEntry);
      result.files.push(file);
    } else if (childEntry.isDirectory) {
      const subFolder = await readDirectoryRecursively(childEntry);
      result.subFolders.push(subFolder);
    }
  }

  return result;
};

export const getEntriesFromDrop = (event) => {
  const items = event.dataTransfer ? event.dataTransfer.items : [];
  const entries = [];

  for (let i = 0; i < items.length; i++) {
    const entry = items[i].webkitGetAsEntry ? items[i].webkitGetAsEntry() : null;
    if (entry) {
      entries.push(entry);
    }
  }

  return entries;
};
